import type { Meilisearch_Relieur } from '@/lib/api/meilisearch-types';

export const computeRelieurPhoto = (relieur: Meilisearch_Relieur) => {
  if (relieur?.photo) return relieur.photo;

  return 'db1682b1-7784-4992-b9cc-3b9561784949';
};
